import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPhone,
    faEnvelope,
    faGlobe,
    faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
    // State to manage hover for each card
    const [isPhoneHovered, setIsPhoneHovered] = useState(false);
    const [isEmailHovered, setIsEmailHovered] = useState(false);
    const [isWebsiteHovered, setIsWebsiteHovered] = useState(false);
    const [isAddressHovered, setIsAddressHovered] = useState(false);

    // Common style for cards
    const cardBaseStyle = {
        height: '100%',
        textAlign: 'center',
        padding: '2rem',
        border: 'none',
        borderRadius: '0.25rem',
        boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
        transition: 'background-color 0.3s ease, transform 0.3s ease',
    };

    // Hover styles
    const cardHoverStyle = {
        backgroundColor: '#f0f4ff',
        transform: 'translateY(-5px)',
    };

    return (
        <section id="contact" style={{ padding: '3rem 0', backgroundColor: '#f8f9fa' }}>
            <div className="container">
                <div className="row justify-content-center mb-5 text-center">
                    <div className="col-lg-8">
                        <h2 className="display-5 fw-bold text-primary mb-4">
                            Get In Touch
                        </h2>
                        <p className="lead text-muted">
                            Ready to streamline your finances? Contact Emkan today for a free consultation.
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="row g-4">
                            {/* Phone Card */}
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div
                                    style={isPhoneHovered ? { ...cardBaseStyle, ...cardHoverStyle } : cardBaseStyle}
                                    onMouseEnter={() => setIsPhoneHovered(true)}
                                    onMouseLeave={() => setIsPhoneHovered(false)}
                                >
                                    <FontAwesomeIcon icon={faPhone} className="text-primary mb-3" style={{ fontSize: '2.5rem' }} />
                                    <h5 className="fw-bold text-primary">Phone</h5>
                                    <p className="mb-2">
                                        <a href="tel:+971588124755" className="text-decoration-none text-dark fw-bold">
                                            +971 58 812 4755
                                        </a>
                                    </p>
                                    <p>
                                     <a href="tel:+971588124755" className="text-decoration-none text-dark fw-bold">
                                            +971 4 570 4638
                                        </a>
                                        </p>
                                    <small className="text-muted">Available 24/7 for emergencies</small>
                                </div>
                            </div>

                            {/* Email Card */}
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div
                                    style={isEmailHovered ? { ...cardBaseStyle, ...cardHoverStyle } : cardBaseStyle}
                                    onMouseEnter={() => setIsEmailHovered(true)}
                                    onMouseLeave={() => setIsEmailHovered(false)}
                                >
                                    <FontAwesomeIcon icon={faEnvelope} className="text-primary mb-3" style={{ fontSize: '2.5rem' }} />
                                    <h5 className="fw-bold text-primary">Email</h5>
                                    <p className="mb-2">
                                        <a href="mailto:gcctax@emkanaccounting.com" className="text-decoration-none text-dark fw-bold">
                                        gcctax@emkanaccounting.com
                                        </a>
                                    </p>
                                    <small className="text-muted">We respond within 24 hours</small>
                                </div>
                            </div>

                            {/* Website Card */}
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div
                                    style={isWebsiteHovered ? { ...cardBaseStyle, ...cardHoverStyle } : cardBaseStyle}
                                    onMouseEnter={() => setIsWebsiteHovered(true)}
                                    onMouseLeave={() => setIsWebsiteHovered(false)}
                                >
                                    <FontAwesomeIcon icon={faGlobe} className="text-primary mb-3" style={{ fontSize: '2.5rem' }} />
                                    <h5 className="fw-bold text-primary">Website</h5>
                                    <p className="mb-2">
                                        <a href="www.emkanaccounting.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark fw-bold">
                                        www.emkanaccounting.com
                                        </a>
                                    </p>
                                    <small className="text-muted">Visit for more information</small>
                                </div>
                            </div>

                            {/* Address Card */}
                            <div className="col-md-6 col-lg-3 mb-4">
                                <div
                                    style={isAddressHovered ? { ...cardBaseStyle, ...cardHoverStyle } : cardBaseStyle}
                                    onMouseEnter={() => setIsAddressHovered(true)}
                                    onMouseLeave={() => setIsAddressHovered(false)}
                                >
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary mb-3" style={{ fontSize: '2.5rem' }} />
                                    <h5 className="fw-bold text-primary">Address</h5>
                                    <p className="mb-2 fw-bold text-dark">
                                        Al Huda Building 208<br />
                                        Deira Dubai, UAE
                                    </p>
                                    <small className="text-muted">Visit us for in-person consultation</small>
                                </div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="text-center mt-4">
                            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                                <a href="tel:+971588124755" className="btn btn-primary btn-lg">
                                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                                    Call Now
                                </a>
                                <a href="https://wa.me/971588124755" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg">
                                    <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
                                    WhatsApp
                                </a>
                                <a href="mailto:gcctax@emkanaccounting.com?subject=Inquiry from Website" className="btn btn-outline-primary btn-lg">
                                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                    Email Us
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;